const tableHeader = ['Cor', 'Nome da cor', 'Código Hexadecimal/Cor', 'Editar', 'Excluir'];

const Tablecadastro = [
  { id: 'nome', title: 'Nome da cor', type: 'text', placeholder: '...' },
  { id: 'hexadecimal', title: 'Hexadecimal', type: 'color', placeholder: ' ...' },
];

const title = 'Cadastro de Cor';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'cor',
};
